import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { userService, cardsService } from '../_services';
import { useLocation, useHistory } from 'react-router-dom';
import { Container, Row, Col, Image } from 'react-bootstrap';

export function AppHeader(props) {
  //console.log(props);
  //console.log(process.env);
  const myCard = cardsService.getCardfromSessionStorage();
  console.log(myCard);
  const [cardID, setCardID] = useState(myCard?.ID || '')
  const [cardName, setCardName] = useState(myCard?.H_FULL_NAME || '');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorLoadingCard, setErrorLoadingCard] = useState('');
  let location = useLocation();
  console.log(location.pathname);

  const { t } = useTranslation();
  const user = props.user;
  const cityLogo = `./assets/imgs/${process.env.REACT_APP_LOGO}`;
  const history = useHistory();


  const searchCard = (event) => {
    event.preventDefault();

    setSubmitted(true);
    //const { username, password, returnUrl } = this.state;
    const card_id = event.target.card_id.value;
    setCardID(card_id);
    setLoading(true);
    cardsService.searchCard({ token: user.token, card_id })
      .then(
        card => {
          console.log(card);
          setLoading(false);
          if (card.error) {
            //let error = this.props.t(card.message.toString().replace(/[\W_]+/g, "_").toLowerCase());                   
            setErrorLoadingCard(card.error);
            setErrorMessage(card.message)
          } else {
            setErrorLoadingCard("");
            setCardName(card.H_FULL_NAME);
            setErrorMessage("")
            props.onCardChanged(card);
          }
        },

      );
  }
  return (
    <Container className="appHeader2" >
      <Row className="receipt-header2">
        <a href={process.env.REACT_APP_WEB_URL} >
          <Image className="img-responsive" src={cityLogo} alt="city logo" />
        </a>
      </Row>
      <Row>
        <h4 className="userName2">{t('hi')} {user?.H_FULL_NAME || user?.DESCRIPTION}</h4>
      </Row>
      {user?.LOGIN_ROLE === "U" &&
        <Row className="wholeLine2 autoCenter2">
          <form className="inline" name="form" onSubmit={searchCard}>
            <div className={' ' + (submitted && !cardID ? ' has-error' : '')}>
              {/*<label htmlFor="card_id">{t('card_id')}</label>*/}
              <input type="text" className="form-control" style={{ 'max-width': '120px' }} name="card_id" value={cardID}
                onChange={e => setCardID(e.target.value)} placeholder={t('card_id')} />
              {loading &&
                <img alt="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
              }
              {errorMessage &&
                <div className="help-block text-danger">{t(errorMessage)}</div>
              }
              {submitted && !cardID &&
                <div className="help-block text-danger">{t('card_id')} {t('required')}</div>
              }
            </div>
          </form>
          <div className="cardName inline" >{errorLoadingCard || cardName} </div>
        </Row>
      }
      <Row className='buttons_row'>

        {location.pathname !== "/" &&
          <Col className="col-4 justify-text">
            <Link className="headerLink headerLinkBg" to="/">{t('invoices')}</Link>
          </Col>
        }

        {(process.env.REACT_APP_PREPAID === "true" && location.pathname !== "/prepaid") &&
          <Col className="col-5 justify-text">
            <Link className="headerLink headerLinkBg" to="/prepaid">{t('prepaid_counters')}</Link>
          </Col>
        }

        {(process.env.REACT_APP_DD === "true" && location.pathname !== "/cc-dd") &&
          <Col className="col-5 justify-text">
            <Link className="headerLink headerLinkBg" to="/cc-dd">{t('cc-dd')}</Link>
          </Col>
        }

        {(user?.LOGIN_ROLE === "U"  && location.pathname !== "/payment-file") &&
          <Col className="col-5 justify-text">
            <Link className="headerLink headerLinkBg" to="/payment-file">{t('payment-file')}</Link>
          </Col>
        }

        <Col>
          <Link to="" onClick={(e) => {
            e.preventDefault();
            userService.logout(history);
          }} >{t('logout')}</Link>
        </Col>
      </Row>
    </Container>

  );
}